import { useAuthStore } from 'src/context/AuthContext';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { Wrapper } from './FeaturesSelection.styles';
import { useAppStore } from 'src/context/AppContext';
import { Resolution } from 'src/types/ViewModel/Resolution';
import SelectResolutionComponent from 'src/components/ui/select-resolution/SelectResolution';
import { SelectResolution } from 'src/types/ViewModel/SelectResolution';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const ResolutionSelectionComponent: React.FC = () => {
    const { defaultResolution, setSelectedResolution, setResolutionList } = useAppStore();
    const { loggedInRole } = useAuthStore();

    // Ref. https://gs.statcounter.com/screen-resolution-stats/desktop/worldwide for resolution statistics
    const _initialResolutionList: Resolution[] = [
        new Resolution(1440, 900),
        new Resolution(1600, 900),
        new Resolution(1920, 1080),
        new Resolution(2560, 1440),
        new Resolution(3440, 1440),
        new Resolution(3840, 2160),
    ];
    const navigate = useNavigate();

    const handleSelectResolutionChange = (resolution: SelectResolution): void => {
        setSelectedResolution(resolution.value);

        navigate({ pathname: '/report-events' });
    };

    useEffect(() => {
        const _resolutionList = [..._initialResolutionList];
        _resolutionList.push(defaultResolution);
        setResolutionList(_resolutionList);
    }, [defaultResolution]);

    return (
        <>
            {loggedInRole?.roleType === RoleTypeEnum.Admin && (
                <>
                    <br></br>
                    <h4>Selected resolution</h4>
                    <Wrapper>
                        <SelectResolutionComponent onChange={handleSelectResolutionChange} />
                    </Wrapper>
                </>
            )}
        </>
    );
};
export default ResolutionSelectionComponent;
